export default __webpack_public_path__ + "static/media/map-pin-fill.8ad64522.svg";